import { RecShapeIfc } from '../shape/RecShapeIfc';
import { SetIfc } from '../set/SetIfc';
import { SetListenerIfc } from '../set/SetListenerIfc';
import { ConcreteSet, RecordUpdater } from '../set/operator/ConcreteSet';
import { ConcreteDriver } from '../set/operator/ConcreteDriver';
import { RecShape } from '../shape/RecShape';
import { Message } from '../../utils/Message';
import { RankingStats } from '../utils/RankingStats';
import { WeeklyEventToRankingItem } from '../../utils/WeeklyEventToRankingItem';
import { WriteRecord } from '../utils/WriteRecord';


	/**
	 * ...
	
			sendShape:
			params[ 0 ] = executionId;
			params[ 1 ] = pipeName;
			params[ 2 ] = EventSourceSender.CREATE_SET_EVENT_NAME;
	
			params[ i++ ] = name;
			params[ i++ ] = under.getTypeAt(name ).getName();
			
			
			begin:
			params[ 0 ] = executionId;
			params[ 1 ] = pipeName;
			params[ 2 ] = EventSourceSender.BEGIN_EVENT_NAME;
			
			
			end:
			params[ 0 ] = executionId; 
			params[ 1 ] = pipeName; 
			params[ 2 ] = EventSourceSender.END_EVENT_NAME;
		
			
			reset:
			params[ 0 ] = executionId;
			params[ 1 ] = pipeName; 
			params[ 2 ] = EventSourceSender.RESET_EVENT_NAME; 
			
			
			addRecord:
			params[ 0 ] = executionId;
			params[ 1 ] = pipeName;
			params[ 2 ] = EventSourceSender.ADD_EVENT_NAME; 
			params[ 3 ] = Integer.tostring(id);
			
			params[ colId * 2 + 3 ] = name;
			params[ colId * 2 + 1 + 3 ] = WriteRecordUtil.tostring(under, id, colId );
			
			deleteRecord:
				params[ 0 ] = executionId;
				params[ 1 ] = pipeName;
				params[ 2 ] = EventSourceSender.DELETE_EVENT_NAME;
				params[ 3 ] = Integer.tostring(id);
			
			
			cellsUpdated:
			params[ 0 ] = executionId;
			params[ 1 ] = pipeName;
			params[ 2 ] = EventSourceSender.UPDATE_EVENT_NAME; 
			params[ 3 ] = Integer.tostring(id);
			
			params[ i * 2 + 4 ] = under.getNames()[ position ];
			params[ i * 2 + 1 + 4 ] = WriteRecordUtil.tostring(under, id, position );
			
			
			setContainerMetaData:
				params[ 0 ] = executionId;
				params[ 1 ] = pipeName;
				params[ 2 ] = EventSourceSender.SET_META_DATA; 
				
				params[ 3 ] = name;
				params[ 4 ] = value;
				
			removeMetaData:
				params[ 0 ] = executionId;
				params[ 1 ] = pipeName;
				params[ 2 ] = EventSourceSender.REMOVE_META_DATA; 				
				params[ 3 ] = name;
			
			setContainerMetaDatas:
				params[ 0 ] = executionId;
				params[ 1 ] = pipeName;
				params[ 2 ] = EventSourceSender.SET_META_DATAS; 
			
				params[ 2 * i + 2 ] = names[ i ];
				params[ 2 * i + 1 + 2 ] = values[ i ];	
				
			removeContainerMetaDatas:
				params[ 0 ] = executionId;
				params[ 1 ] = pipeName;
				params[ 2 ] = EventSourceSender.REMOVE_META_DATAS; 
				params[ i + 2 ] = names[ i ];	
	 * 
	 * 
	 * 
	 */

export class EventsSourceRunner {
	public static EVENT_SOURCE_USER_ACTION:string = "eventSourceUserActionCommand";
    public static EVENT_SOURCE_SG_NAME:string = "EventSourceMessage";
    public static ADD_EVENT_NAME:string = "ADD";
    public static DELETE_EVENT_NAME:string = "DELETE";
    public static RESET_EVENT_NAME:string = "RESET";
    public static BEGIN_EVENT_NAME:string = "BEGIN";
    public static END_EVENT_NAME:string = "END";
    public static UPDATE_EVENT_NAME:string = "UPDATE";
    public static CREATE_SET_EVENT_NAME:string = "CREATE_SET";
    
    public static ADD_META_DATA:string = "ADD_META_DATA";
    public static ADD_META_DATAS:string = "ADD_META_DATAS";
    public static REMOVE_META_DATA:string = "REMOVE_META_DATA";
    public static REMOVE_META_DATAS:string = "REMOVE_META_DATAS";
  
    public static TOTAL_SORTING_PIPE:string = "TOTAL_SORTING_PIPE";
    public static TOTAL_SORTING_Buffer:string = "TOTAL_SORTING_Buffer";
    public static TOTAL_SORTING_EventConverterListener:string = "TOTAL_SORTING_EventConverterListener";
    
    public static WEEKLY_SORTING_PIPE:string = "WeeklySortingPipe";
    public static WEEKLY_SORTING_Buffer:string = "WeeklySortingByffer";
    public static WEEKLY_SORTING_EventConverterListener:string = "WeeklySortingEventConverter";
    
    public static WEEKLY_FRIENDS_PIPE:string = "WeeklyFilterFriendsPipe";
    public static WEEKLY_FRIENDS_Buffer:string = "WeeklyFriendsByffer";
    public static WEEKLY_FRIENDS_EventConverterListener:string = "WeeklyFriendsEventConverter";

	
		//String -> ConcreteDriver
		drivers:Map<string, ConcreteDriver>;
		//String -> SetIfc
		operators:Map<string, SetIfc>;
		//String -> ( String -> Object (operator, listener, driver, source ) )
		listeners:Map<string, Map<string, any>>;
		// String -> String
		listensOn:Map<string, string>;
		
		protected flashvars: any;

		convertToBoolean(input: string): boolean {
		  try {
			  return JSON.parse(input);
		  }
		  catch (e) {
			  console.error(e);
			  return undefined;
		  }
		}
	
		public handleEventSourceEvent( msg:Message ):void {
			let executionId:string = msg.params[ 0 ];
			//to avoid situation where we receive messages from provious run - sometimes heppens when player refreshes browser
			if( this.flashvars.newPostponedToken == executionId ){
			  if( msg.name == EventsSourceRunner.EVENT_SOURCE_SG_NAME ){
				switch( msg.params[ 2 ] ) {
				  case EventsSourceRunner.ADD_EVENT_NAME:
					this.decodeAdd( msg );
					break;
				  case EventsSourceRunner.DELETE_EVENT_NAME:
					this.decodeDelete( msg );
					break;
				  case EventsSourceRunner.RESET_EVENT_NAME:
					this.decodeReset( msg );
					break;
				  case EventsSourceRunner.BEGIN_EVENT_NAME:
					this.decodeBegin( msg );
					break;
				  case EventsSourceRunner.END_EVENT_NAME:
					this.decodeEnd( msg );
					break;
				  case EventsSourceRunner.UPDATE_EVENT_NAME:
					this.decodeUpdate( msg );
					break;
				  case EventsSourceRunner.CREATE_SET_EVENT_NAME:
					this.decodeSendShape( msg );
					break; 
				  case EventsSourceRunner.ADD_META_DATA:
					this.decodeSetContainerMeta( msg );
					break;
				  case EventsSourceRunner.ADD_META_DATAS:
					this.decodeSetContainerMetaDatas( msg );
					break;
				  case EventsSourceRunner.REMOVE_META_DATA:
					this.decodeRemoveMetaData( msg );
					break;
				  case EventsSourceRunner.REMOVE_META_DATAS:
					this.decodeRemoveContainerMetaDatas( msg );
					break;
				  default:
					throw Error( "Not recognized type of event: " + msg.params[ 2 ] );
				}
			  }
			}
		  }
		  
		constructor() 
		{
			this.drivers = new Map<string, ConcreteDriver>();
			this.operators = new Map<string, SetIfc>();
			this.listeners = new Map<string, Map<string, any>>();
			this.listensOn = new Map<string, string>();
		}
		
		public getShape( operatorName:string ):RecShapeIfc{
			return this.operators.get( operatorName ).getShape();
		}
		
		//for example join, one set with given name to many sets
		public addOperatorManyInput( tos:Array<string>, name:string, factory:Function ):void{
			var sets:Array<SetIfc> = new Array<SetIfc>();
			for( let i:number = 0; i < tos.length; i++ ){
				sets[i] = this.operators.get( tos[i] );
			}
			let newSet:SetIfc = factory.call( sets );
			for( let i:number = 0; i < tos.length; i++ ){
				var to:string = tos[i];
				this.operators.set(name, newSet );
				this.listeners.get(to).set( name, newSet );
				this.listeners.set( name, new Map<string, string>() );
				this.listensOn.set(name, to );
			}
		}
	
		public addOperator( to:string, name:string, factory:Function ):void{
			let under:SetIfc = this.operators.get( to );
			let newSet:SetIfc = factory.call( this, under );
			this.operators.set(name, newSet );
			this.listeners.get( to ).set( name, newSet );
			this.listeners.set( name, new Map<string, string>() );
			this.listensOn.set( name, to );
		}

		private isEmpty( dict:Map<string, string> ):number{
			let count:number = 0;
			dict.forEach( (val:string, key:string, map:Map<string, string>) => {
				count++;
			});
			return count;
		}
		
		private removeOperatorInCalcThread( name:string ):void {
			let theSet:SetIfc = this.operators.get( name );
			let under:string = this.listensOn.get( name );

			let setListeners:Map<string, any> = this.listeners.get( name );

			let emptyAtStart:boolean = setListeners.size <= 0;
			
			setListeners.forEach( (val:string, key:string, map:Map<string, any>) => {
				if( setListeners.get(key).isSet === 'function' ){
					this.removeOperatorInCalcThread( key );
				}else{
                    if ( setListeners.get(key).isSetListener === 'function' ) {
                        this.removeOperatorInCalcThread( key );
                    }
                }
			});

			if( this.operators.get( name ) == null ) {
				throw new Error("Operators collection doesn't contain operator: " + name );
			}else {
				this.operators.delete(name);
			}
			if( this.drivers.get( name ) == null && this.listensOn.get( name ) == null ){
				throw new Error("Listeners edges doesn't contain operator: " + name );
			}else {
				if( this.drivers.get( name ) == null ){ 
					this.listensOn.delete(name);
				}
			}
			if( this.drivers.get( name ) == null && this.listeners.get(under).get(name) == null ){	
				throw new Error("Listeners collection for: " + under + " doesn't contain operator: " + name );
			}else {
				if( this.drivers.get( name ) == null ){ 
					this.listeners.get(under).delete(name);
				}
			}
			if( !emptyAtStart &&  this.listeners.get( name ).size <= 0  ){
				throw new Error("Listeners collection not empty at start and not empty at the end.");
			}else {
				this.listeners.delete( name );
			}
			theSet.destruct();
		}
		
		public removeListenerInCalcThread( name:string):void {
			var under:string = this.listensOn.get( name );
			this.listensOn.delete( name );
			let listener:SetListenerIfc = this.listeners.get( under ).get( name );
			this.listeners.get( under ).delete( name );
			this.operators.get( under ).removeListener(listener);
		}
		
		public removeOperator( name:string ):void{
			this.removeOperatorInCalcThread(name);
		}

		public removeListener( name:string ):void{
			this.removeListenerInCalcThread(name);
		}
	
		public addListenerInCalcThread( to:string, name:string, listener:SetListenerIfc):void{
			this.listensOn.set( name, to );
			this.listeners.get( to ).set( name, listener );
			this.operators.get( to ).addListener(listener);
		}
	
		public addListener( to:string, name:string, factory:Function ):void {
			let listener:SetListenerIfc = factory.call( this, this.operators.get( to ).getShape() );
			this.addListenerInCalcThread(to, name, listener);
		}
		
		private addDriverInCalcThread( name:string, shape:RecShapeIfc):void{
			let cSet:ConcreteSet  = new ConcreteSet(shape);
			let driver:ConcreteDriver = new ConcreteDriver(cSet);
			this.drivers.set( name, driver );
			this.operators.set( name, cSet );
			this.listeners.set( name, new Map<string, string>() );
		}
	
		public getDriver( name:string ):ConcreteDriver{
			return this.drivers.get( name );
		}
		public removeDriver( name:string ):void{
			this.removeOperatorInCalcThread(name);
			let driver:ConcreteDriver = this.drivers.get( name );
			this.drivers.delete( name );
			driver.destruct(false);
			driver = null;				
		}
		
		public addDriver( name:string, types:Array<string>, names:Array<string> ):void{
			let shape:RecShapeIfc = new RecShape(types, names);
			this.addDriverInCalcThread(name, shape);				
		}
		
		public addSimpleDriver( name:string, types:Array<string>):void{
			let shape:RecShape = new RecShape(types);
			this.addDriverInCalcThread(name, shape);				
		}



		public addTotalListener( rankingStats:RankingStats ):void{
			this.addListener( EventsSourceRunner.TOTAL_SORTING_Buffer, EventsSourceRunner.TOTAL_SORTING_EventConverterListener, function( under:RecShapeIfc ):SetListenerIfc { 
			  return new WeeklyEventToRankingItem(
				EventsSourceRunner.TOTAL_SORTING_EventConverterListener,
				this.gameService, under, rankingStats, this.imageService, this.applicationController );
			} );
		  }
		  
		  public addWeeklyListener( rankingStats:RankingStats ):void{
			this.addListener( EventsSourceRunner.WEEKLY_SORTING_Buffer, EventsSourceRunner.WEEKLY_SORTING_EventConverterListener, function( under:RecShapeIfc ):SetListenerIfc { 
			  return new WeeklyEventToRankingItem( EventsSourceRunner.WEEKLY_SORTING_EventConverterListener,
				this.gameService, under, rankingStats, this.imageService, this.applicationController );
			} );
		  }
		  
		  public addFriendsWeeklyListener( rankingStats:RankingStats ):void{
			this.addListener( EventsSourceRunner.WEEKLY_FRIENDS_Buffer, EventsSourceRunner.WEEKLY_SORTING_EventConverterListener, function( under:RecShapeIfc ):SetListenerIfc { 
			  return new WeeklyEventToRankingItem( EventsSourceRunner.WEEKLY_SORTING_EventConverterListener,
				this.gameService, under, rankingStats, this.imageService, this.applicationController );
			} );
		  }
		  
		  /*
		  sendShape:
			params[ 0 ] = executionId;
			params[ 1 ] = pipeName;
			params[ 2 ] = EventSourceSender.CREATE_SET_EVENT_NAME;
		
			params[ i++ ] = name;
			params[ i++ ] = under.getTypeAt(name ).getName();
		  */
		  public decodeSendShape( msg:Message ):void {
			let pipeName:string = msg.params[ 1 ];
			
			let driver:ConcreteDriver = this.getDriver( pipeName );
			if( driver == null ){
			  //add source
			}else {
			  //we have source validate
			}
		  }
		  
		  /*
		  begin:
			params[ 0 ] = executionId;
			params[ 1 ] = pipeName;
			params[ 2 ] = EventSourceSender.BEGIN_EVENT_NAME;
		  */
		  public decodeBegin( msg:Message ):void{
			let pipeName:string = msg.params[ 1 ];
			let driver:ConcreteDriver = this.getDriver( pipeName );
			driver.begin();
		  }
		  
		  /*
		  end:
			params[ 0 ] = executionId; 
			params[ 1 ] = pipeName; 
			params[ 2 ] = EventSourceSender.END_EVENT_NAME;
		  */
		  public decodeEnd( msg:Message ):void{
			let pipeName:string = msg.params[ 1 ];
			let driver:ConcreteDriver = this.getDriver( pipeName );
			driver.end();
		  }
		  
		  /*
		  reset:
			params[ 0 ] = executionId;
			params[ 1 ] = pipeName; 
			params[ 2 ] = EventSourceSender.RESET_EVENT_NAME; 
		  */
		  public decodeReset( msg:Message ):void{
			let pipeName:string = msg.params[ 1 ];
			let driver:ConcreteDriver = this.getDriver( pipeName );
			driver.reset();	
		  }
		  
		  /*
		  addRecord:
			params[ 0 ] = executionId;
			params[ 1 ] = pipeName;
			params[ 2 ] = EventSourceSender.ADD_EVENT_NAME; 
			params[ 3 ] = Integer.tostring(id);
			
			params[ colId * 2 + 3 ] = name;
			params[ colId * 2 + 1 + 3 ] = WriteRecordUtil.tostring(under, id, colId );
		  */
		  public decodeAdd( msg:Message ):void {
			let pipeName:string = msg.params[ 1 ];
			let driver:ConcreteDriver = this.getDriver( pipeName );
			let id:number = parseInt( msg.params[ 3 ]  );
			let record:WriteRecord = driver.getRecord( id );
			
			for ( let i:number = 4; i < msg.params.length; i += 2) {
			  let colName:string = msg.params[ i ];
			  
			  let colId:number = driver.getShape().getColId( colName );
			  let type:string = driver.getShape().getType( colId );
			  
			  switch( type ) {
				case "string":
				  record.setStringAt( colId, msg.params[ i + 1] );
				  break;
				case "Number":
				  record.setNumberAt( colId, parseInt(msg.params[ i + 1] ));
				  break;
				case "int":
				  record.setIntAt( colId, parseInt(msg.params[ i + 1 ] ));
				  break;
				case "Boolean":
				  record.setBooleanAt( colId, this.convertToBoolean(msg.params[ i + 1 ] ));
				  break;
				default:
				  throw new Error( "Unknown type: " + type );
			  }
			}
			driver.addRecord( record.getId() );
		  }
		  
		  /*
		  cellsUpdated:
			params[ 0 ] = executionId;
			params[ 1 ] = pipeName;
			params[ 2 ] = EventSourceSender.UPDATE_EVENT_NAME; 
			params[ 3 ] = Integer.tostring(id);
			
			params[ i * 2 + 4 ] = under.getNames()[ position ];
			params[ i * 2 + 1 + 4 ] = WriteRecordUtil.tostring(under, id, position );
		  */
		  public decodeUpdate( msg:Message ):void{
			let pipeName:string = msg.params[ 1 ];
			let driver:ConcreteDriver = this.getDriver( pipeName );
			let id:number = parseInt( msg.params[ 3 ]  );
			let updater:RecordUpdater = driver.getUpdater( id );
		
			for ( let i:number = 4; i < msg.params.length; i += 2) {
			  let colName:string = msg.params[ i ];
			  
			  let colId:number = driver.getShape().getColId( colName );
			  let type:string = driver.getShape().getType( colId );
			  
			  switch( type ) {
				case "string":
				  updater.setStringAt( colId, msg.params[ i + 1] );
				  break;
				case "Number":
				  updater.setNumberAt( colId, parseInt(msg.params[ i + 1] ));
				  break;
				case "int":
				  updater.setIntAt( colId, parseInt(msg.params[ i + 1 ] ));
				  break;
				case "Boolean":
				  updater.setBooleanAt( colId, this.convertToBoolean(msg.params[ i + 1 ]));
				  break;
				default:
				  throw new Error( "Unknown type: " + type );
			  }				
			}
			updater.flush();
		  }
		  
		  /*
		  deleteRecord:
			params[ 0 ] = executionId;
			params[ 1 ] = pipeName;
			params[ 2 ] = EventSourceSender.DELETE_EVENT_NAME;
			params[ 3 ] = Integer.tostring(id);
		  */
		  public decodeDelete( msg:Message ):void{
			let pipeName:string = msg.params[ 1 ];
			let driver:ConcreteDriver = this.getDriver( pipeName );
			let id:number = parseInt( msg.params[ 3 ]  );
			
			driver.deleteRecord( id );
		  }
		  
		  /*
		  setContainerMetaData:
			params[ 0 ] = executionId;
			params[ 1 ] = pipeName;
			params[ 2 ] = EventSourceSender.SET_META_DATA; 
			
			params[ 3 ] = name;
			params[ 4 ] = value;
		  */
		  public decodeSetContainerMeta( msg:Message):void{
			let pipeName:string = msg.params[ 1 ];
			let driver:ConcreteDriver = this.getDriver( pipeName );
			
			let name:string = msg.params[ 3 ];
			let value:string = msg.params[ 4 ];
			
			driver.setContainerMetaData( name, value );
		  }
		  
		  /*
		  removeMetaData:
			params[ 0 ] = executionId;
			params[ 1 ] = pipeName;
			params[ 2 ] = EventSourceSender.REMOVE_META_DATA; 				
			params[ 3 ] = name;
		  */
		  public decodeRemoveMetaData( msg:Message ):void {
			let pipeName:string = msg.params[ 1 ];
			let driver:ConcreteDriver = this.getDriver( pipeName );
			
			let name:string = msg.params[ 3 ];
			
			driver.removeMetaData( name );
		  }
		  
		  /*
		  setContainerMetaDatas:
			params[ 0 ] = executionId;
			params[ 1 ] = pipeName;
			params[ 2 ] = EventSourceSender.SET_META_DATAS; 
		
		  
			params[ 2 * i + 3 ] = names[ i ];
			params[ 2 * i + 1 + 3 ] = values[ i ];	
			
		  */
		  public decodeSetContainerMetaDatas( msg:Message ):void{
			let pipeName:string = msg.params[ 1 ];
			let driver:ConcreteDriver = this.getDriver( pipeName );
			
			let names:Array<string> = new Array();
			let values:Array<string> = new Array();
			for ( let i:number = 0; i * 2 + 3 < msg.params.length; i++){
			  names[ i ] = msg.params[ 2 * i + 3 ];
			  values[ i ] = msg.params[ 2 * i + 1 + 3 ];	
			}
			
			driver.setContainerMetaDatas( names, values );
		  }
		  
		  /*			
		  removeContainerMetaDatas:
			params[ 0 ] = executionId;
			params[ 1 ] = pipeName;
			params[ 2 ] = EventSourceSender.REMOVE_META_DATAS; 
			params[ i + 2 ] = names[ i ];	
		  */	
		  public decodeRemoveContainerMetaDatas( msg:Message ):void{
			let pipeName:string = msg.params[ 1 ];
			let driver:ConcreteDriver = this.getDriver( pipeName );
			
			let names:Array<string> = new Array();
			for ( let i:number = 0; i + 3 < msg.params.length; i++){
			  names[ i ] = msg.params[ i + 3 ];
			}
			
			driver.removeContainerMetaDatas( names );
		  }
}
